import PropTypes from 'prop-types';
import { useMemo } from 'react';
import useTotalPrice from '../../../../hooks/useTotalPrice/useTotalPrice';
import useTranslate from '../../../../hooks/useTranslate/useTranslate';

const TotalPriceBox = ({ bookings, currency }) => {
  const { dt, t } = useTranslate();
  const {
    totalPrice,
    differentCurrencies,
    totalPriceInBaseCurrency,
    propertyCurrency = { symbol: '', code: '' },
  } = useTotalPrice(bookings);

  const alternateCurrency = useMemo(() => {
    return bookings.some((booking) => {
      return booking.roomRate.currencyCode !== currency;
    });
  }, [bookings, currency]);

  if (differentCurrencies) return null;

  return (
    <div className="d-flex flex-column">
      <div
        className="d-flex flex-column"
        style={{
          border: ' 1px solid #dbd9d9',
          fontWeight: 600,
          padding: '25px 30px',
        }}
      >
        <div className="d-flex justify-content-between">
          <div className="text-uppercase">{t('Est. Total')}</div>
          <div>
            <div className="d-flex justify-content-end">{totalPrice}</div>
            <div style={{ fontWeight: 400 }}>({t('Tax Included')})</div>
          </div>
        </div>
        {alternateCurrency ? (
          <>
            <div className="d-flex justify-content-between mt-4">
              <div className="text-uppercase">{t('Property will charge')}</div>
              <div>
                <div className="d-flex justify-content-end">
                  {totalPriceInBaseCurrency}
                </div>
                <div style={{ fontWeight: 400 }}>({t('Tax Included')})</div>
              </div>
            </div>
            <div>
              {dt(
                [
                  '*',
                  '{code}',
                  '(',
                  '{symbol}',
                  ')',
                  'is the local currency of the hotel',
                ],
                {
                  code: propertyCurrency.code,
                  symbol: propertyCurrency.symbol,
                }
              )}
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

TotalPriceBox.propTypes = {
  bookings: PropTypes.array.isRequired,
  currency: PropTypes.string,
};

export default TotalPriceBox;
